var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttEffectedInteraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 27",
    width: "84px",
    height: "27px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -652, -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 27,
    rx: 13.5,
    transform: "translate(652 579)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 602.263 1304.709 C 599.205 1304.724 596.56 1306.842 595.878 1309.823 L 592.935 1309.823 C 591.849 1304.92 585.862 1303.031 582.158 1306.424 C 581.171 1307.329 580.486 1308.515 580.196 1309.823 L 577.253 1309.823 C 576.161 1304.914 570.164 1303.028 566.458 1306.429 C 565.473 1307.333 564.789 1308.518 564.499 1309.823 L 561.556 1309.823 C 560.45 1304.923 554.455 1303.058 550.765 1306.465 C 547.074 1309.873 548.456 1315.998 553.253 1317.49 C 556.917 1318.63 560.77 1316.376 561.572 1312.623 L 564.483 1312.623 C 565.544 1317.544 571.535 1319.471 575.267 1316.091 C 576.28 1315.173 576.981 1313.96 577.269 1312.623 L 580.181 1312.623 C 581.234 1317.538 587.214 1319.47 590.944 1316.1 C 591.961 1315.18 592.664 1313.964 592.951 1312.623 L 595.862 1312.623 C 596.92 1317.544 602.908 1319.475 606.641 1316.099 C 610.375 1312.722 609.052 1306.57 604.262 1305.025 C 603.615 1304.817 602.941 1304.711 602.262 1304.71 L 602.263 1304.709 Z",
    transform: "translate(115.343 -718.709)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttEffectedInteraction);
export default __webpack_public_path__ + "static/media/att-effected-interaction.931b634e8f087886d914a97bee128bd8.svg";
export { ForwardRef as ReactComponent };